module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-3da8923f.png";